import { StyledDateInput } from './DatePicker.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `DatePicker` atom lets a user select a date (using the browser's native date picker UI).
 * Use the `StyledLabel` atom to provide a label.
 */
export const DatePicker = ({
  required,
  onChangeCallback,
  disablePastDates,
  minDate,
  ...rest
}) => {
  const date = new Date();
  return /*#__PURE__*/_jsx(StyledDateInput, {
    ...rest,
    type: "date",
    role: "textbox"
    // if minDate exists, min = minDate || if disablePastDates = true, set min = todays date in YYYY-MM-DD || min = undefined
    ,
    min: minDate || (disablePastDates ? date.toISOString().split('T')[0] : undefined),
    required: required,
    onChange: e => onChangeCallback && onChangeCallback(e.target.value)
  });
};